<template>
	<v-container>
		<Piechart class="piechartclass" />
		<v-row class="contentRow">
			<div class="divbottom">
				<h2>Define probability</h2>
				<br/>
				<ol class="detailbottom2">
					<li v-for="(item, index) in items" :key="index">
						<template v-if="!item.editing">
							{{ item.text }}
							<v-icon @click="startEditing(index)" style="color: #217b7f" class="edit-button">fa-solid
								fa-pen-to-square</v-icon>
						</template>
						<template v-else>
							<input type="text" v-model="item.text" class="edit-input" placeholder="sijsjsf"/>
							<v-icon @click="saveEdit(item.text, item.ID,index)" style="color: #217b7f" class="save-button">fa-solid
								fa-floppy-disk</v-icon>

						</template>
					</li>
				</ol>
			</div>
		</v-row>
	</v-container>
</template>

<script>
import Piechart from "../components/Riskdefinitiontable.vue"
import { riskAPI } from "../api/csr/riskdef"
import LoadingState from "../consts/LoadingState"
export default {
	components: {
		Piechart,
	},
	data() {
		return {
			items: [],
			probs: [
				{ text: "Happens very rarely (once every 5 years or more rarely)", editing: false },
				{ text: "Happens no more than once per year, but more often than every 5 years", editing: false },
				{ text: "Happens no more than once per month, but more often than once per year", editing: false },
				{ text: "Happens 1 time per month", editing: false },
				{ text: "Happens once a week", editing: false }
			],
			isSaved:false
		}
	},
	mounted() {
		this.loadItems()
	},
	methods: {
		loadItems() {
			this.items = []
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, { root: true })
			riskAPI.getAllProbs()
				.then((data) => {
					console.log("Define probability:", data)
					if(data[0].length>0){
						data[0].forEach((entry, index)=> {
							console.log("probability:", index)
							this.items.push({
								text:entry.Description,
								editing: false,
								ID:entry.ID
							})
						})
					}else{
						this.probs.forEach((entry, index)=> {
							console.log("probability11:", index)
							this.items.push({
								text:entry.text,
								editing: false
							})
							this.isSaved =true
						})
					}

					this.$store.dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, { root: true })

				})
				.catch((error) => {
					console.error("Error fetching data:", error)
					this.$store.dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, { root: true })
				})
		},
		startEditing(index) {
			this.items[index].editing = true
		},
		async saveEdit(text, ID,index) {
			this.items[index].editing = false
			console.log("Index ",index)
			console.log(text)
			if(this.isSaved){
				for (let i = 0; i < this.probs.length; i++) {
					if(i==index){
						try {
							await riskAPI.saveAllProbs(
								i + 1,
								text
							)
							this.isSaved =false
						} catch (error) {
							console.error("Error saving risks:", error)
							alert("An error occurred while saving the risks.")
							break // Exit the loop if an error occurs
						}
					}else{
						try {
							await riskAPI.saveAllProbs(
								i + 1,
								this.probs[i].text
							)
							this.isSaved =false
						} catch (error) {
							console.error("Error saving risks:", error)
							alert("An error occurred while saving the risks.")
							break // Exit the loop if an error occurs
						}
					}
					console.log("probability12:", i+1)

				}
			}else{
				console.log("probability123:" ,ID,text)
				try {
					await riskAPI.updateRiskprobById(
						ID,
						text
					)
				} catch (error) {
					console.error("Error saving risks:", error)
					alert("An error occurred while saving the risks.")
				}
			}
			this.loadItems()
		},
		saveAllEdits() {
			// Implement logic to save all edits
		}
	}
}
</script>

<style scoped>
.piechartclass {
	margin-bottom: 0;
}

h2 {
	display: flex;
	align-items: flex-start;
}

ol {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}


li {
	padding-bottom: 30px;
	flex-direction: row;
}

.edit-button,
.save-button {
	font-size: 20px;
	padding: 5px 5px;
	margin-left: 10px;
	border: none;
	cursor: pointer;
	border-radius: 4px;
}

.edit-input {
	font-size: 14px;
	padding: 5px 10px;
	margin-left: 10px;
	border: 1px solid #ced4da;
	border-radius: 4px;
	width: 550px;
	min-width: 100px;
}
</style>
